// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","CategoriesList":"bj_a bhy_ea bhy_ke bhy_ju bhy_wl"};